var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9516_28646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9516_28646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9516_28646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H4V19H19V4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9516_28646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8559 4.35596C11.6456 4.35596 11.4367 4.36506 11.2297 4.38316L11.3734 6.04016C11.5314 6.02666 11.6927 6.01976 11.8559 6.01976C13.3719 6.02026 14.7366 6.63166 15.7311 7.62466C16.7241 8.61946 17.3361 9.98406 17.3361 11.5001C17.3361 13.0161 16.7241 14.3808 15.7311 15.3752C14.7366 16.3683 13.3719 16.9798 11.8559 16.9802C10.3399 16.9798 8.9753 16.3683 7.9808 15.3752C7.4464 14.8402 7.0277 14.1952 6.7498 13.4798L7.661 13.3516L5.3104 9.91656L4.7851 11.5001H4.7123C4.7123 11.5643 4.7199 11.6267 4.7218 11.6907L4 13.8662L5.0668 13.7163C5.9999 16.576 8.6845 18.6437 11.8559 18.6439C15.802 18.6437 18.9995 15.4459 19 11.5001C18.9995 7.55406 15.802 4.35626 11.8559 4.35596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31201 8.43622C7.40151 8.30342 7.49761 8.17422 7.59891 8.04842L6.30561 7.00232C6.17481 7.16412 6.05011 7.33132 5.93311 7.50522L7.31201 8.43622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67646 6.47004C9.94246 6.35474 10.2194 6.26004 10.5054 6.18744L10.0971 4.57434C9.72306 4.66904 9.36146 4.79324 9.01416 4.94414L9.67646 6.47004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90293 6.88314L8.00453 5.48254C7.68243 5.68884 7.37833 5.92055 7.09473 6.17435L8.20393 7.41414C8.42183 7.21934 8.65553 7.04134 8.90293 6.88314Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9516_28646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDashboard);
export default __webpack_public_path__ + "static/media/refresh-dashboard.e50ef1e47ac56f3734ec3caa03f55af5.svg";
export { ForwardRef as ReactComponent };